import { VenueConfig, VenuePage } from "../../types/venues";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { dmnStorage } from "../../utils/dmnStorage";
import { getEnvironmentProps } from "../../utils/environment";
import { errorHandler, throwApiError } from "../errorHandler";

type getVenueConfigType = {
  venues: VenuePage[] | undefined;
};
export const getDefaultVenue = async ({ venues }: getVenueConfigType) => {
  if (!venues?.[0]?._id) {
    return;
  }
  let defaultVenueId = venues[0]._id;
  const storedVenueId = await dmnStorage.get("venueId");

  if (storedVenueId) {
    const venueIdFound = venues.find((v) => v._id === storedVenueId);
    if (venueIdFound) {
      defaultVenueId = storedVenueId;
    }
  }

  return defaultVenueId;
};

export const fetchVenueConfig = async (
  id: string | undefined
): Promise<VenueConfig | undefined> => {
  if (!id) {
    return undefined;
  }
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(
      `${environmentVars?.CORE_API_BASE_URL}/venues/${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      await throwApiError(response, "Error fetching venue config");
    }

    const venueConfig = (await response.json()).payload?.venue;

    if (!venueConfig) {
      errorHandler(
        new Error("Venue config not found"),
        "Error fetching venue config"
      );
      return undefined;
    }

    return venueConfig;
  } catch (error) {
    errorHandler(error, "Error fetching venue config");
    return undefined;
  }
};
